module.exports = __webpack_public_path__ + "img/logo-full.e2ca2125.png";